import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import formatDate from 'utils/formatDate';
import { Amount } from '../Amount/Amount';
import { PercentageDisplay } from '../PercentageDisplay/PercentageDisplay';
import DurationLabel from '../DurationLabel';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FC, Dispatch, SetStateAction, useCallback } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dl: {
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: theme.palette.background.default,
      margin: theme.spacing(1, 0),
      padding: '8px 12px',
      borderRadius: '7px',
    },
    dt: {
      display: 'flex',
      alignContent: 'center',
      minWidth: '34%',
    },
    dd: {
      textAlign: 'right',
      margin: 0,
      minWidth: '34%',
    },
  })
);

const displayValue = (
  value: any,
  type?: 'string' | 'currency' | 'date' | 'percentage' | 'duration' | 'boolean'
) => {
  switch (type) {
    case 'currency':
      return value === undefined || value === null ? '-' : <Amount value={value} variant="label" />;
    case 'percentage':
      return <PercentageDisplay value={value} emptyValue="-" />;
    case 'duration':
      return <DurationLabel months={value} />;
    case 'date':
      return <>{formatDate(value, '-')}</>;
    case 'boolean':
      return <>{value === true ? 'Ja' : value === false ? 'Nee' : '-'}</>;
    default:
      return value ? <>{value}</> : <>-</>;
  }
};

export type DetailsRowProps = {
  label: string;
  value?: any;
  type?: 'string' | 'currency' | 'date' | 'percentage' | 'duration' | 'boolean';
  isLoanPart?: boolean;
  children?: React.ReactNode;
  isInfoBoxOpen?: boolean;
};

export const DetailsRow: FC<DetailsRowProps> = ({
  label,
  value,
  type,
  isLoanPart,
  children,
  isInfoBoxOpen,
}) => {
  const classes = useStyles();

  return (
    <dl
      className={classes.dl}
      data-testid="client-details-column"
      style={isLoanPart ? { backgroundColor: '#fff' } : {}}
    >
      <dt className={classes.dt}>
        {label}
        {isInfoBoxOpen && <InfoOutlinedIcon style={{ marginRight: 5, cursor: 'pointer' }} />}
      </dt>
      <dd className={classes.dd}>{children || displayValue(value, type)}</dd>
    </dl>
  );
};
